/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkPropertyContactRequest
 */
export interface LinkPropertyContactRequest {
    /**
     * 
     * @type {number}
     * @memberof LinkPropertyContactRequest
     */
    contactId: number;
    /**
     * 
     * @type {string}
     * @memberof LinkPropertyContactRequest
     */
    addressType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkPropertyContactRequest
     */
    isPrimary?: boolean;
}

/**
 * Check if a given object implements the LinkPropertyContactRequest interface.
 */
export function instanceOfLinkPropertyContactRequest(value: object): value is LinkPropertyContactRequest {
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    return true;
}

export function LinkPropertyContactRequestFromJSON(json: any): LinkPropertyContactRequest {
    return LinkPropertyContactRequestFromJSONTyped(json, false);
}

export function LinkPropertyContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkPropertyContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contactId': json['contactId'],
        'addressType': json['addressType'] == null ? undefined : json['addressType'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
    };
}

export function LinkPropertyContactRequestToJSON(json: any): LinkPropertyContactRequest {
    return LinkPropertyContactRequestToJSONTyped(json, false);
}

export function LinkPropertyContactRequestToJSONTyped(value?: LinkPropertyContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactId': value['contactId'],
        'addressType': value['addressType'],
        'isPrimary': value['isPrimary'],
    };
}

